import { Image } from '@starsoft/common/components';
import { BetAmountInputCoinProps } from './props';
import styles from './styles.module.scss';
import { useWalletsMe } from '@/api/wallets';
import { BetStatus } from '@/models/bet/status';
import { useResolvedTheme } from '@/hooks/theme/useResolvedTheme';
import { SettingLayoutComponentId } from '@starsoft/common/models/setting/layout/component/componentId.enum';
import { ComponentTypeId } from '@starsoft/common/models/setting/layout/component/type/types.enum';
import { BetStatusId } from '@/models/bet/status/id';

export default function BetAmountInputCoin({ bet }: BetAmountInputCoinProps) {
  const { wallet } = useWalletsMe();
  const { components } = useResolvedTheme();
  const version: string =
    components.get(ComponentTypeId.BetAmountInput?.toString()) ??
    SettingLayoutComponentId.BetAmountInputV1?.toString();

  const isV4Version: boolean =
    version === SettingLayoutComponentId.BetAmountInputV4?.toString();

  if (bet && bet?.status?.id?.toString() === BetStatusId.Open?.toString()) {
    return (
      <div
        className={`${styles.container} ${+version > SettingLayoutComponentId.BetAmountInputV1 ? styles['container--left'] : ''} ${isV4Version ? styles['container--v4'] : ''}`}
      >
        <Image
          className={styles.container__image}
          alt={`coin-icon-${bet?.coin?.name}`}
          format="square"
          width={30}
          height={30}
          src={`${
            process.env.NEXT_PUBLIC_S3_BUCKET_BASE_URL
          }/coins/rounded/${bet?.coin?.image ?? 'usd.svg'}`}
        />
        {isV4Version && bet?.coin?.code}
      </div>
    );
  }
  return (
    <div
      className={`${styles.container} ${+version > SettingLayoutComponentId.BetAmountInputV1 ? styles['container--left'] : ''} ${isV4Version ? styles['container--v4'] : ''}`}
    >
      <Image
        className={styles.container__image}
        alt={`coin-icon-${wallet?.currentAccount?.coin?.name}`}
        format="square"
        width={30}
        height={30}
        src={`${process.env.NEXT_PUBLIC_S3_BUCKET_BASE_URL}/coins/rounded/${wallet?.currentAccount?.coin?.image ?? 'usd.svg'}`}
      />
      {isV4Version && wallet?.currentAccount?.coin?.code}
    </div>
  );
}
